import { FaAnchor } from "react-icons/fa";
import { publishAll } from "../utils/publishAll";
import { StructureBuilder } from "sanity/structure";
import { STRUCTURE_API_VERSION } from "./apiVersion";
import { RiMap2Line } from "react-icons/ri";

export default (S: StructureBuilder) =>
  S.listItem()
    .title("Ports & Excursions")
    .icon(FaAnchor)
    .child(
      S.list()
        .title("Ports & Excursions")
        .items([
          S.listItem()
            .title("Ports")
            .schemaType("port")
            .child(
              S.documentTypeList("port").menuItems([
                ...(S.documentTypeList("port").getMenuItems() || []),
                S.menuItem()
                  .title("Publish all")
                  .action(() =>
                    publishAll("port", S.context.getClient, S.context.schema)
                  )
              ])
            ),
          S.listItem()
            .title("Shore Excursions")
            .schemaType("shorex")
            .child(S.documentTypeList("shorex")),
          S.listItem()
            .title("Land Programmes")
            .schemaType("landProgramme")
            .child(S.documentTypeList("landProgramme")),
          S.listItem()
            .title("Hotels")
            .schemaType("hotel")
            .child(S.documentTypeList("hotel")),
          S.listItem()
            .title("Land Experiences")
            .icon(RiMap2Line)
            .child(
              S.list()
                .title("Land Experiences")
                .items([
                  S.listItem()
                    .title("Land Programmes")
                    .schemaType("landExperience")
                    .child(
                      S.documentTypeList("landExperience")
                        .filter(`type == "landProgramme"`)
                        .apiVersion(STRUCTURE_API_VERSION)
                    ),
                  S.listItem()
                    .title("City Stays")
                    .schemaType("landExperience")
                    .child(
                      S.documentTypeList("landExperience")
                        .filter(`type == "cityStay"`)
                        .apiVersion(STRUCTURE_API_VERSION)
                    )
                ])
            )
        ])
    );
